var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { store } from '../../../store';
import { sendWebsocketMessage } from '../../../helpers/websocket';
import PlayerComponent from './player';
import { DataMessage, DataMsgBodyType, DataMsgType, } from '../../../helpers/proto/plugnmeet_datamessage_pb';
const VideoJsPlayerComponent = ({ src, action, seekTo, isPresenter, }) => {
    _react_refresh_temp_2();
    const [player, setPlayer] = useState();
    const session = store.getState().session;
    const [options] = useState({
        controls: isPresenter,
        responsive: true,
        fluid: true,
        sources: [
            {
                src,
            },
        ],
    });
    useEffect(() => {
        if (isPresenter || !player) {
            return;
        }
        if (action === 'play') {
            player.play();
        }
        else if (action === 'pause') {
            player.pause();
        }
    }, [action, isPresenter, player]);
    useEffect(() => {
        if (isPresenter || !player) {
            return;
        }
        if (seekTo > 1) {
            player.currentTime(seekTo);
        }
    }, [seekTo, player, isPresenter]);
    useEffect(() => {
        const broadcast = (msg) => {
            var _a, _b, _c, _d;
            const dataMsg = new DataMessage({
                type: DataMsgType.SYSTEM,
                roomSid: session.currentRoom.sid,
                roomId: session.currentRoom.room_id,
                body: {
                    type: DataMsgBodyType.EXTERNAL_MEDIA_PLAYER_EVENTS,
                    from: {
                        sid: (_b = (_a = session.currentUser) === null || _a === void 0 ? void 0 : _a.sid) !== null && _b !== void 0 ? _b : '',
                        userId: (_d = (_c = session.currentUser) === null || _c === void 0 ? void 0 : _c.userId) !== null && _d !== void 0 ? _d : '',
                    },
                    msg,
                },
            });
            sendWebsocketMessage(dataMsg.toBinary());
        };
        if (player) {
            player.on('pause', () => {
                const msg = {
                    action: 'pause',
                };
                broadcast(JSON.stringify(msg));
            });
            player.on('play', () => {
                const msg = {
                    action: 'play',
                    seekTo: player.currentTime(),
                };
                broadcast(JSON.stringify(msg));
            });
            player.on('seeked', () => {
                const msg = {
                    action: 'seeked',
                    seekTo: player.currentTime(),
                };
                broadcast(JSON.stringify(msg));
            });
        }
    }, [player]);
    const onReady = (player) => {
        setPlayer(player);
    };
    return _jsx(PlayerComponent, { options: options, onReady: onReady });
};
_react_refresh_temp_1 = VideoJsPlayerComponent;
$RefreshReg$(_react_refresh_temp_1, "VideoJsPlayerComponent");
_react_refresh_temp_2(VideoJsPlayerComponent, "+cWHNSzNwg7hjM2jb3xcErvVt6A=");
export default VideoJsPlayerComponent;
